<template>
    <div class="t-reg-event__wrap">
        <div class="t-form__wrap2">
            <h2 class="t-reg-event__title" v-html="props.formInfo.title"></h2>
            <div class="t-form__subtext" v-html="props.formInfo.description"></div>

            <form-dynamic-cmp
                class="_width-big _reviews"
                :form-info="props.formInfo"
                :button="props.button"
                :class-white="false"
            >
            </form-dynamic-cmp>
        </div>
    </div>
</template>

<script>
    import {mapActions} from "vuex";
    import formDynamic from '@components/base/form-dynamic.vue';

    export default {
        name: "feedback",
        props: ['props'],
        data() {
            return {
                infoForm: {
                    action: "feedback/send",
                    disabledForm: false,
                    isPersonalData: false,
                    errorPersonalData: false,
                    success: false,
                    error: false,
                },
            }
        },
        watch: {
            'infoForm.success': function() {
                if (this.infoForm.success) {
                    this.modalClose();
                    this.modalType_successOpen({
                        title: this.$root.staticText.modal.successTitleFeedback,
                        text: this.$root.staticText.modal.successTextFeedback,
                        class: '_small'
                    });
                }

            },
            'infoForm.error': function() {
                if (this.infoForm.error) {
                    this.modalClose();
                    this.modalType_errorOpen({
                        title: this.$root.staticText.modal.errorTitle,
                        text: this.$root.staticText.modal.errorText,
                        class: '_small'
                    });
                }
            }
        },
        components: {
            'form-dynamic-cmp': formDynamic,
        },
        methods: {
            ...mapActions('modal', ['modalType_successOpen', 'modalType_errorOpen', 'modalClose']),
        }
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/components/base/modals/collab.vue